import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  Paper,
  MenuItem,
  Grid,
  IconButton,
  InputAdornment,
} from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Swal from "sweetalert2";
import { register as registerApi } from "../../services/authService";
import { useNavigate } from "react-router-dom";

// Importa el DatePicker y Adapter de MUI
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

const Register = () => {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    confirmPassword: "",
    firstName: "",
    lastName: "",
    birthDate: null, // Cambiado de age a birthDate (Date o null)
    documentType: "",
    documentNumber: "",
    telephone: "",
    gender: "",
  });

  const [isEmailValid, setIsEmailValid] = useState(false);
  const [doPasswordsMatch, setDoPasswordsMatch] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    setIsEmailValid(emailRegex.test(email));
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    setFormData((prevData) => {
      const updatedData = {
        ...prevData,
        [name]: value,
      };

      if (name === "password" || name === "confirmPassword") {
        setDoPasswordsMatch(
          updatedData.password === updatedData.confirmPassword
        );
      }

      return updatedData;
    });

    if (name === "email") {
      validateEmail(value);
    }
  };

  // Maneja el cambio en el DatePicker
  const handleDateChange = (newValue) => {
    setFormData((prevData) => ({
      ...prevData,
      birthDate: newValue,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    try {
      const userData = {
        Correo: formData.email,
        Contraseña: formData.password,
        idRol: 1,
        PrimerNombre: formData.firstName,
        PrimerApellido: formData.lastName,
        Celular: formData.telephone,
        // Enviamos la fecha en formato ISO (yyyy-mm-dd)
        FechaNacimiento: formData.birthDate
          ? formData.birthDate.toISOString().split("T")[0]
          : null,
        Genero: formData.gender,
        TipoDoc: formData.documentType,
        Documento: formData.documentNumber,
      };

      console.log(userData)

      const response = await registerApi(userData);

      if (response.success) {
        Swal.fire({
          icon: "success",
          title: "Registro Exitoso",
          text: response.message,
        });
        navigate("/login");
      } else {
        Swal.fire({
          icon: "error",
          title: "Error al Registrar",
          text: response.message || "Hubo un problema al registrar.",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error del Servidor",
        text: error.message || "Error inesperado",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        background: "#a5b967",
        minHeight: "100vh",
        position: "relative",
        padding: 2,
      }}
    >
      <IconButton
        onClick={() => navigate("/login")}
        sx={{
          position: "absolute",
          top: 16,
          left: 16,
          backgroundColor: "white",
          color: "#a5b967",
          "&:hover": {
            backgroundColor: "#f0f0f0",
          },
        }}
      >
        <ArrowBackIosNewIcon fontSize="small" />
      </IconButton>

      <Box
        component={Paper}
        elevation={3}
        sx={{
          maxWidth: 600,
          mx: "auto",
          mt: 8,
          p: 4,
          borderRadius: 2,
          backgroundColor: "white",
        }}
      >
        <Typography variant="h5" fontWeight="bold" gutterBottom align="center">
          Regístrate en BioPlastic
        </Typography>
        <Typography variant="body1" align="center" sx={{ mb: 3 }}>
          Completa los datos para hacer el registro
        </Typography>

        <Grid container spacing={1.5}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              size="medium"
              error={!isEmailValid && formData.email !== ""}
              helperText={
                !isEmailValid && formData.email !== ""
                  ? "Email no válido"
                  : ""
              }
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Nombre"
              name="firstName"
              value={formData.firstName}
              onChange={handleInputChange}
              size="medium"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Apellido"
              name="lastName"
              value={formData.lastName}
              onChange={handleInputChange}
              size="medium"
            />
          </Grid>

          {/* Aquí reemplazamos Edad por DatePicker para Fecha de Nacimiento */}
          <Grid item xs={12} sm={6}>
            <DatePicker
              label="Fecha de Nacimiento"
              value={formData.birthDate}
              onChange={handleDateChange}
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  size="medium"
                />
              )}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Celular"
              type="number"
              name="telephone"
              value={formData.telephone}
              onChange={handleInputChange}
              size="medium"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              select
              label="Género"
              name="gender"
              value={formData.gender}
              onChange={handleInputChange}
              size="medium"
            >
              <MenuItem value="Masculino">Masculino</MenuItem>
              <MenuItem value="Femenino">Femenino</MenuItem>
            </TextField>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              select
              label="Tipo de Documento"
              name="documentType"
              value={formData.documentType}
              onChange={handleInputChange}
              size="medium"
            >
              <MenuItem value="CC">Cédula de Ciudadanía</MenuItem>
              <MenuItem value="TI">Tarjeta de Identidad</MenuItem>
              <MenuItem value="CE">Cédula de Extranjería</MenuItem>
              <MenuItem value="PAS">Pasaporte</MenuItem>
            </TextField>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Número Documento"
              name="documentNumber"
              value={formData.documentNumber}
              onChange={handleInputChange}
              size="medium"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Contraseña"
              type={showPassword ? "text" : "password"}
              name="password"
              value={formData.password}
              onChange={handleInputChange}
              size="medium"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowPassword((prev) => !prev)}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Confirmar Contraseña"
              type={showConfirmPassword ? "text" : "password"}
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleInputChange}
              size="medium"
              error={!doPasswordsMatch && formData.confirmPassword !== ""}
              helperText={
                !doPasswordsMatch && formData.confirmPassword !== ""
                  ? "Las contraseñas no coinciden"
                  : ""
              }
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowConfirmPassword((prev) => !prev)}
                      edge="end"
                    >
                      {showConfirmPassword ? (
                        <VisibilityOff />
                      ) : (
                        <Visibility />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
        </Grid>

        <Button
          variant="contained"
          fullWidth
          sx={{
            mt: 3,
            backgroundColor: "#a5b967",
            "&:hover": { backgroundColor: "#8da253" },
          }}
          disabled={
            !isEmailValid ||
            !doPasswordsMatch ||
            formData.password === "" ||
            loading
          }
          onClick={handleSubmit}
        >
          {loading ? "Registrando..." : "Registrar"}
        </Button>
      </Box>
    </Box>
  );
};

export default Register;
